import { render, staticRenderFns } from "./EligibleForMoreLoan.vue?vue&type=template&id=66812672&scoped=true&"
import script from "./EligibleForMoreLoan.vue?vue&type=script&lang=js&"
export * from "./EligibleForMoreLoan.vue?vue&type=script&lang=js&"
import style0 from "./EligibleForMoreLoan.vue?vue&type=style&index=0&id=66812672&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66812672",
  null
  
)

export default component.exports